import { useTranslation } from 'react-i18next'
import { CREATOR, CONTACT, SOCIAL_LINKS } from '../data/creator'

type Lang = 'zh' | 'en'

function pickLang(raw: string): Lang {
  return raw.toLowerCase().startsWith('en') ? 'en' : 'zh'
}

export function useCreator() {
  const { i18n } = useTranslation()
  const lang = pickLang(i18n.language)
  return {
    name: CREATOR.name[lang],
    title: CREATOR.title[lang],
    avatar: CREATOR.avatar,
    bio: CREATOR.bio[lang],
    philosophy: CREATOR.philosophy[lang],
    email: CONTACT.email,
    galleryUrl: CONTACT.galleryUrl,
    websiteUrl: CONTACT.websiteUrl,
    social: SOCIAL_LINKS,
  }
}
